import { schoolTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;
let schoolManagement = `${SCHOOL_BASE}/school`;

export const getClassDropdown = (params) => {
  return schoolTokenAxios.get(`${schoolManagement}/getClassDropdown/${params}`);
};
